import { Link } from 'react-router-dom';
import { today, type SeasonView } from '../data.js';
import { homeBlocks, isInGroup } from '../session-utils.js';
import MatchCard from '../components/MatchCard.js';

/**
 * The home screen (§6.2): a heading and a card per group, for each week worth showing. The
 * cards carry the whole answer, so there is nothing to tap through to — the link to the full
 * schedule sits under them as a shortcut to the same place the menu goes.
 */
export default function Home({ view, playerId }: { view: SeasonView; playerId: string }) {
  const groups = view.groups.filter((g) => isInGroup(g, playerId));
  const blocks = homeBlocks(groups, today(view));

  if (groups.length === 0) {
    return <p className="muted">You're not on a roster this season.</p>;
  }

  return (
    <>
      {blocks.map((block) => (
        <section className="week-block" key={block.title}>
          <h2>{block.title}</h2>
          {block.matches.map(({ group, session }) => (
            <MatchCard
              key={`${group.config.groupId}-${session.date}`}
              view={view}
              group={group}
              session={session}
              playerId={playerId}
            />
          ))}
        </section>
      ))}

      {/* The season is over, or hasn't started — nothing to show, and saying so beats an
          empty screen that reads as a failure to load. */}
      {blocks.length === 0 && (
        <p className="muted">No matches coming up — the season is done.</p>
      )}

      <p className="season-link">
        <Link to="/season">See the full season schedule</Link>
      </p>
    </>
  );
}
